(($) => {
	/**
	 * Gulp include scripts
	 *
	 * @link https://www.npmjs.com/package/gulp-include
	 */
	//=require ../../template-parts/blocks/example/block-example.js

	/**
	 * jQuery Document Ready
	 *
	 * @link https://learn.jquery.com/using-jquery-core/document-ready/
	 */
	$(() => {
		// Mobile hamburger
		document
			.querySelector(".hamburger")
			.addEventListener("click", function () {
				this.classList.toggle("active");

				const mobileMenu = document.querySelector(".mobile-menu");
				if (this.classList.contains("active")) {
					mobileMenu.classList.add("active");
				} else {
					mobileMenu.classList.remove("active");
				}
			});

		// Mobile sublinks
		document
			.querySelectorAll(".js-mobile-sublinks")
			.forEach(function (button) {
				button.addEventListener("click", function (e) {
					e.preventDefault();

					const parentLi = this.closest("li");
					if (parentLi && parentLi.classList.contains("active")) {
						parentLi.classList.remove("active");
					} else {
						document
							.querySelectorAll(".mobile-secondary")
							.forEach(function (otherLi) {
								otherLi
									.closest("li")
									.classList.remove("active");
							});

						if (parentLi) {
							parentLi.classList.add("active");
						}
					}
				});
			});

		// Desktop sublinks
		document.querySelectorAll(".js-links").forEach((link) => {
			link.addEventListener("mouseenter", () => {
				link.classList.add("active");
			});

			link.addEventListener("mouseleave", () => {
				link.classList.remove("active");
			});
		});

		// Product Slider Slick Init
		const $product_slider = $(".block-product-slider .product-slider");
		if ($product_slider.length) {
			$product_slider.each(function () {
				const $el = $(this);
				if (!$el.hasClass("slick-initialized")) {
					$el.slick({
						slidesToShow: 4,
						slidesToScroll: 1,
						autoplay: true,
						autoplaySpeed: 7000,
						arrows: true,
						dots: false,
						infinite: true,
						pauseOnHover: true,
						responsive: [
							{
								breakpoint: 991,
								settings: {
									slidesToShow: 3,
									slidesToScroll: 1,
								},
							},
							{
								breakpoint: 776,
								settings: {
									slidesToShow: 2,
									slidesToScroll: 1,
								},
							},
							{
								breakpoint: 640,
								settings: {
									slidesToShow: 1,
									slidesToScroll: 1,
								},
							},
						],
						appendArrows: $el,
						nextArrow:
							'<button type="button" class="slick-next" aria-label="Next">' +
							'<svg xmlns="http://www.w3.org/2000/svg" viewBox="13 10 12 20" width="12" height="20" fill="none">' +
							'<path fill-rule="evenodd" clip-rule="evenodd" d="M24.45 29.4499C24.0984 29.8011 23.6219 29.9983 23.125 29.9983C22.6281 29.9983 22.1516 29.8011 21.8 29.4499L13.675 21.3249C13.3239 20.9734 13.1267 20.4968 13.1267 19.9999C13.1267 19.5031 13.3239 19.0265 13.675 18.6749L21.8 10.5499C22.1554 10.2187 22.6256 10.0384 23.1113 10.047C23.5971 10.0556 24.0605 10.2524 24.4041 10.5959C24.7476 10.9394 24.9444 11.4029 24.9529 11.8886C24.9615 12.3744 24.7812 12.8445 24.45 13.1999L17.65 19.9999L24.45 26.7999C24.8011 27.1515 24.9984 27.6281 24.9984 28.1249C24.9984 28.6218 24.8011 29.0984 24.45 29.4499Z" fill="#919393"/>' +
							"</svg>" +
							"</button>",
						prevArrow:
							'<button type="button" class="slick-prev" aria-label="Previous">' +
							'<svg xmlns="http://www.w3.org/2000/svg" viewBox="13 10 12 20" width="12" height="20" fill="none">' +
							'<path fill-rule="evenodd" clip-rule="evenodd" d="M24.45 29.4499C24.0984 29.8011 23.6219 29.9983 23.125 29.9983C22.6281 29.9983 22.1516 29.8011 21.8 29.4499L13.675 21.3249C13.3239 20.9734 13.1267 20.4968 13.1267 19.9999C13.1267 19.5031 13.3239 19.0265 13.675 18.6749L21.8 10.5499C22.1554 10.2187 22.6256 10.0384 23.1113 10.047C23.5971 10.0556 24.0605 10.2524 24.4041 10.5959C24.7476 10.9394 24.9444 11.4029 24.9529 11.8886C24.9615 12.3744 24.7812 12.8445 24.45 13.1999L17.65 19.9999L24.45 26.7999C24.8011 27.1515 24.9984 27.6281 24.9984 28.1249C24.9984 28.6218 24.8011 29.0984 24.45 29.4499Z" fill="#919393"/>' +
							"</svg>" +
							"</button>",
					});
				}
			});
		}

		// Card Slider Slick Init
		const $card_slider = $(".block-card-slider .card-slider");
		if ($card_slider.length) {
			$card_slider.each(function () {
				const $el = $(this);
				const count =
					parseInt($el.data("count"), 10) ||
					$el.children(".card").length;

				// desktop: >3, below 992px: >=3
				const isTablet =
					window.matchMedia("(max-width: 991px)").matches;
				const shouldInit = isTablet ? count >= 3 : count > 3;
				if (!shouldInit) return;

				if (!$el.hasClass("slick-initialized")) {
					$el.slick({
						slidesToShow: 3,
						slidesToScroll: 1,
						autoplay: true,
						autoplaySpeed: 7000,
						arrows: true,
						dots: false,
						infinite: true,
						pauseOnHover: true,
						appendArrows: $el,
						responsive: [
							{
								breakpoint: 991,
								settings: {
									slidesToShow: 2,
									slidesToScroll: 1,
								},
							},
							{
								breakpoint: 640,
								settings: {
									slidesToShow: 1,
									slidesToScroll: 1,
								},
							},
						],
						nextArrow:
							'<button type="button" class="slick-next" aria-label="Next">' +
							'<svg xmlns="http://www.w3.org/2000/svg" viewBox="13 10 12 20" width="12" height="20" fill="none">' +
							'<path fill-rule="evenodd" clip-rule="evenodd" d="M24.45 29.4499C24.0984 29.8011 23.6219 29.9983 23.125 29.9983C22.6281 29.9983 22.1516 29.8011 21.8 29.4499L13.675 21.3249C13.3239 20.9734 13.1267 20.4968 13.1267 19.9999C13.1267 19.5031 13.3239 19.0265 13.675 18.6749L21.8 10.5499C22.1554 10.2187 22.6256 10.0384 23.1113 10.047C23.5971 10.0556 24.0605 10.2524 24.4041 10.5959C24.7476 10.9394 24.9444 11.4029 24.9529 11.8886C24.9615 12.3744 24.7812 12.8445 24.45 13.1999L17.65 19.9999L24.45 26.7999C24.8011 27.1515 24.9984 27.6281 24.9984 28.1249C24.9984 28.6218 24.8011 29.0984 24.45 29.4499Z" fill="#919393"/>' +
							"</svg>" +
							"</button>",
						prevArrow:
							'<button type="button" class="slick-prev" aria-label="Previous">' +
							'<svg xmlns="http://www.w3.org/2000/svg" viewBox="13 10 12 20" width="12" height="20" fill="none">' +
							'<path fill-rule="evenodd" clip-rule="evenodd" d="M24.45 29.4499C24.0984 29.8011 23.6219 29.9983 23.125 29.9983C22.6281 29.9983 22.1516 29.8011 21.8 29.4499L13.675 21.3249C13.3239 20.9734 13.1267 20.4968 13.1267 19.9999C13.1267 19.5031 13.3239 19.0265 13.675 18.6749L21.8 10.5499C22.1554 10.2187 22.6256 10.0384 23.1113 10.047C23.5971 10.0556 24.0605 10.2524 24.4041 10.5959C24.7476 10.9394 24.9444 11.4029 24.9529 11.8886C24.9615 12.3744 24.7812 12.8445 24.45 13.1999L17.65 19.9999L24.45 26.7999C24.8011 27.1515 24.9984 27.6281 24.9984 28.1249C24.9984 28.6218 24.8011 29.0984 24.45 29.4499Z" fill="#919393"/>' +
							"</svg>" +
							"</button>",
					});
				}
			});
		}

		// Testimonial Slider Slick Init
		const $testimonial_slider = $(
			".block-testimonial-slider .testimonial-slider"
		);
		if ($testimonial_slider.length) {
			$testimonial_slider.each(function () {
				const $el = $(this);
				if (!$el.hasClass("slick-initialized")) {
					$el.slick({
						slidesToShow: 1,
						slidesToScroll: 1,
						autoplay: true,
						autoplaySpeed: 7000,
						arrows: true,
						dots: true,
						infinite: true,
						pauseOnHover: true,
						appendArrows: $el,
						nextArrow:
							'<button type="button" class="slick-next" aria-label="Next">' +
							'<svg xmlns="http://www.w3.org/2000/svg" viewBox="13 10 12 20" width="12" height="20" fill="none">' +
							'<path fill-rule="evenodd" clip-rule="evenodd" d="M24.45 29.4499C24.0984 29.8011 23.6219 29.9983 23.125 29.9983C22.6281 29.9983 22.1516 29.8011 21.8 29.4499L13.675 21.3249C13.3239 20.9734 13.1267 20.4968 13.1267 19.9999C13.1267 19.5031 13.3239 19.0265 13.675 18.6749L21.8 10.5499C22.1554 10.2187 22.6256 10.0384 23.1113 10.047C23.5971 10.0556 24.0605 10.2524 24.4041 10.5959C24.7476 10.9394 24.9444 11.4029 24.9529 11.8886C24.9615 12.3744 24.7812 12.8445 24.45 13.1999L17.65 19.9999L24.45 26.7999C24.8011 27.1515 24.9984 27.6281 24.9984 28.1249C24.9984 28.6218 24.8011 29.0984 24.45 29.4499Z" fill="#919393"/>' +
							"</svg>" +
							"</button>",
						prevArrow:
							'<button type="button" class="slick-prev" aria-label="Previous">' +
							'<svg xmlns="http://www.w3.org/2000/svg" viewBox="13 10 12 20" width="12" height="20" fill="none">' +
							'<path fill-rule="evenodd" clip-rule="evenodd" d="M24.45 29.4499C24.0984 29.8011 23.6219 29.9983 23.125 29.9983C22.6281 29.9983 22.1516 29.8011 21.8 29.4499L13.675 21.3249C13.3239 20.9734 13.1267 20.4968 13.1267 19.9999C13.1267 19.5031 13.3239 19.0265 13.675 18.6749L21.8 10.5499C22.1554 10.2187 22.6256 10.0384 23.1113 10.047C23.5971 10.0556 24.0605 10.2524 24.4041 10.5959C24.7476 10.9394 24.9444 11.4029 24.9529 11.8886C24.9615 12.3744 24.7812 12.8445 24.45 13.1999L17.65 19.9999L24.45 26.7999C24.8011 27.1515 24.9984 27.6281 24.9984 28.1249C24.9984 28.6218 24.8011 29.0984 24.45 29.4499Z" fill="#919393"/>' +
							"</svg>" +
							"</button>",
					});
				}
			});
		}
	});
})(jQuery);
